import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Bonjour!',
  ProductCode: 'feq42',
  Description:
    '<p>Here&#39;s all the online content included with your <strong>French Exam Practice Workbook</strong>.</p>',
  Credits:
    '<p><i>With thanks to Marie-Laure Delvallée for the proofreading.</i></p>\n' +
    '\n' +
    '<p><i>Audio produced by Voice Talent Online.</i></p>\n' +
    '\n' +
    '<p><i>Questions throughout are based on Pearson Edexcel-type questions.</i></p>\n' +
    '\n' +
    '<p><i>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2025.&nbsp; All rights reserved.</i></p>\n',
};
